import {Link} from '@nlabs/gothamjs/router';
import type {ReactNode} from 'react';
import type {Article} from '../types/article';
import {articlePath} from '../routes/articlePath';

interface ArticleLinkProps {
  article: Article;
  children: ReactNode;
  className?: string;
}

export const ArticleLink = ({article, children, className}: ArticleLinkProps) => {
  return <Link className={className} to={articlePath(article)}>{children}</Link>;
};
